import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {lastValueFrom} from "rxjs";
import {NzMessageService} from "ng-zorro-antd/message";
import {PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-po-invoice",
    templateUrl: "./po-invoice.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PoInvoiceComponent implements OnInit {
    hasZonalScanDir = false;
    loading = true;
    uploading = false;
    selectedFile?: File;

    constructor(
        private readonly api: PerFormaAPIService,
        private readonly msg: NzMessageService
    ) {}

    async ngOnInit() {
        try {
            this.hasZonalScanDir = await lastValueFrom(this.api.getApiPTPPOInvoiceZonalDirExists());
        } finally {
            this.loading = false;
        }
    }

    onFileChange(event: Event) {
        const input = event.target as HTMLInputElement;
        this.selectedFile = input.files?.[0];
    }

    upload = async () => {
        if (!this.selectedFile) {
            this.msg.error("Select a file");
            return;
        }

        this.uploading = true;
        try {
            await lastValueFrom(this.api.postApiPTPPOInvoice({file: this.selectedFile}));
            this.msg.success("File uploaded.");
            this.selectedFile = undefined;
        } catch (e) {
            const err = (e as {error?: unknown})?.error;
            this.msg.error(typeof err === "string" ? err : "Upload failed.");
        } finally {
            this.uploading = false;
        }
    };
}
